import { useQuery } from "react-query";
import AttributeDataService from "../../services/attribute-data-service/AttributeDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IAttributeSchemaModel } from "../../services/attribute-data-service/Models";

export type UseAttributesSchemaParameters = {
    organizationID: number,
    groupID: number,
    id: number,
    name: string
} & BaseUseQueryParameters<IAttributeSchemaModel | undefined>;

export function useAttributeSchema({
    organizationID,
    groupID,
    id,
    name,
    enabled,
    onError,
    onSuccess,
}: UseAttributesSchemaParameters) {
    return useQuery<IAttributeSchemaModel | undefined, RestError>(
        keys.attributeSchema(organizationID, groupID, id),
        ({ signal }) => {
            return AttributeDataService.getAttributeSchema(
                organizationID,
                groupID, 
                id,
                name,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            //staleTime: Infinity
            staleTime: 0,
            //refetchOnMount: 'always'
            refetchOnWindowFocus: false

        }
    );
}